export const isFullStatic = false
export const staticPath = "/root/project/frontend/.nuxt/static-json"
export const publicPath = "https://frontenddev.builtin.com/45f523a78f71d2a75638cbd98016e44c9623217f/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"